import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import AuthReducer, * as fromAuth from './AuthReducer';
import CaseReducer, * as fromCase from './CaseReducer';
import SnapshotReducer from './SnapshotReducer';
import ModalReducer from './ModalReducer';
import OpenSeadragonReducer, * as fromOpenSeadragon from './OpenSeadragonReducer';
import { RESET_APP_STATE } from '../actions/types';
import CadessDataReducer from './CadessDataReducer';
import NotificationReducer from './NotificationReducer';

const appReducer = combineReducers({
  auth: AuthReducer,
  _case: CaseReducer,
  form: formReducer,
  snapshot: SnapshotReducer,
  modal: ModalReducer,
  openSeadragon: OpenSeadragonReducer,
  cadessData: CadessDataReducer,
  notification: NotificationReducer,
});

/*
  The rootReducer  consists of all reducers.
  When an action of type RESET_APP_STATE is dispatched,
  state is set to undefined, & redux does it's magic:
  All of the reducers' state will be set to their initial state
*/
const rootReducer = (state, action) => {
  if (action.type === RESET_APP_STATE) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;

/* SELECTORS
  These selectors used to read specific data from the redux store.
  Use them, in mapStateToProps, and pass in `state` as argument.

  So... why are all of these selectors defined in this file?
  Checkout this tutorial by Dan Abramov, creator of redux:
  https://egghead.io/lessons/javascript-redux-colocating-selectors-with-reducers
*/

/* Auth Selectors */
export const getSignedInUser = (state) =>
  fromAuth.getSignedInUser(state.auth);

export const getRoleOfSignedInUser = (state) =>
  fromAuth.getRoleOfSignedInUser(state.auth);

export const checkIfUserIsAuthenticated = (state) =>
  fromAuth.checkIfUserIsAuthenticated(state.auth);

export const checkIfAppIsCurrentlyVerifyingUser = (state) =>
  fromAuth.checkIfAppIsCurrentlyVerifyingUser(state.auth);

/* Case Selectors */
export const getIdOfSelectedPathologist = (state) =>
  fromCase.getIdOfSelectedPathologist(state._case);

export const getSpecimensWithUnsavedChanges = (state) =>
  (fromCase.getUnsavedSpecimenUploads(state._case));

export const checkIfChangesShouldBeTemporarilyStoredInClient = (state) =>
  (fromCase.checkIfChangesShouldBeTemporarilyStoredInClient(state._case));

export const checkIfSpecimenOverlayIsVisible = (state) =>
  (fromCase.checkIfSpecimenOverlayIsVisible(state._case));

export const checkIfASpecimenIsSelected = (state) =>
  (fromCase.checkIfASpecimenIsSelected(state._case));

export const getIdOfSelectedSpecimen = (state) =>
  (fromCase.getIdOfSelectedSpecimen(state._case));

export const getSelectedCase = (state) => fromCase.getSelectedCase(state._case);

export const getCurrentCase = (state) => fromCase.getCurrentCase(state._case);

export const getIdOfSelectedCase = (state) => fromCase.getIdOfSelectedCase(state._case);

export const getCaseGeneralInfoPropertyValueInSelectedCase = (state, property) => (
  fromCase.getCaseGeneralInfoPropertyValueInSelectedCase(state._case, property)
);


/* OpenSeadragon Selectors */
export const getBoundsForSpecimenImage = (state, id) =>
  (fromOpenSeadragon.getBoundsForSpecimenImage(state.openSeadragon, id));

export const getRotationForSpecimenImage = (state, id) => {
  return (fromOpenSeadragon.getRotationForSpecimenImage(state.openSeadragon, id));
};
